// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"9ad0b8bf","307":"1220a891","362":"604a4491","453":"7b37988b","633":"e98c3e81","778":"696855f9","797":"c60768fd"}[chunkId] + ".chunk.js";
};